module.exports = __webpack_public_path__ + "img/huodong1.85e1555.png";